import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
	faCheck,
	faCircleCheck,
	faDollarSign,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheck, faCircleCheck, faDollarSign)

@Component({
	components: {},
})
export default class BadgePerson extends Vue {
	@Prop({ default: '' }) readonly imageUrl
	@Prop({ default: '' }) readonly tooltip
	@Prop({ default: '' }) readonly status
}
